/* Event countdown. Config: window.BFC from snippets/bf-countdown-config.liquid */
(function () {
  var C = window.BFC;
  if (!C || window.__bfcBound) return;
  window.__bfcBound = true;

  var root = document.documentElement;
  // Resolved from Pacific time in snippets/bf-countdown-config.liquid
  var start = C.startMs;
  var end = C.endMs;
  var timer = null;
  var observer = null;
  var orderKey = '';

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function setAll(sel, val) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      if (els[i].textContent !== val) els[i].textContent = val;
    }
  }

  function state(now) {
    // Invalid times or end not after start: never show.
    if (isNaN(start) || isNaN(end) || end <= start) return 'invalid';
    if (now < start) return 'pre';
    return now >= end && !C.hourlyLoop ? 'post' : 'live';
  }

  // Grid tile: appended last inside the SearchSpring results grid (never spliced
  // between Preact-managed nodes) and positioned with CSS `order`.
  function gridList() {
    return document.querySelector('#searchspring-content .ss__results');
  }

  function ensureTile() {
    var list = gridList();
    if (!list) return;
    var tile = list.querySelector(':scope > .bfc-tile');
    if (!tile) {
      var tpl = document.getElementById('bfc-tile-tpl');
      if (!tpl || !tpl.content.firstElementChild) return;
      tile = tpl.content.firstElementChild.cloneNode(true);
      list.appendChild(tile);
    } else if (tile !== list.lastElementChild) {
      list.appendChild(tile);
    }
    // Product cards carry a bottom margin, plus a little space under the Quick Add
    // button. Match both so the desktop tile ends flush with the Quick Add buttons.
    var card = list.querySelector(':scope > .ss__result');
    if (card) {
      var mb = parseFloat(getComputedStyle(card).marginBottom) || 0;
      var qa = !mqMobile.matches && card.querySelector('.quick-add-button');
      if (qa && qa.offsetHeight) {
        var gap = card.getBoundingClientRect().bottom - qa.getBoundingClientRect().bottom;
        if (gap > 0 && gap < 80) mb += gap;
      }
      var mbPx = Math.round(mb) + 'px';
      if (tile.style.marginBottom !== mbPx) tile.style.marginBottom = mbPx;
    }
    updateOrder(list);
  }

  function updateOrder(list) {
    var cols = getComputedStyle(list).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
    var mobile = window.matchMedia('(max-width: 768px)').matches;
    var k = mobile ? cols * C.gridRowMobile + 1 : C.gridSlot;
    var key = cols + ':' + k;
    if (key === orderKey) return;
    orderKey = key;
    var style = document.getElementById('bfc-order');
    if (!style) {
      style = document.createElement('style');
      style.id = 'bfc-order';
      document.head.appendChild(style);
    }
    // The theme's clearfix ::after is a grid item too; keep it at the end.
    style.textContent =
      '#searchspring-content .ss__results::after{order:3}' +
      '#searchspring-content .ss__results > .bfc-tile{order:1}' +
      '#searchspring-content .ss__results > :not(.bfc-tile):nth-child(n+' + k + '){order:2}';
  }

  // Mobile strip pin: once the in-grid strip scrolls up under the header, a fixed copy
  // of it stays pinned just below the header for the rest of the page.
  var pin = null;
  var mqMobile = window.matchMedia('(max-width: 768px)');

  function ensurePin() {
    if (pin) return pin;
    var tpl = document.getElementById('bfc-tile-tpl');
    var strip = tpl && tpl.content.querySelector('.bfc--strip');
    if (!strip) return null;
    var link = tpl.content.querySelector('a.bfc-tile__inner');
    pin = document.createElement('div');
    pin.className = 'bfc-pin';
    var holder = pin;
    if (link) {
      holder = document.createElement('a');
      holder.href = link.getAttribute('href');
      pin.appendChild(holder);
    }
    holder.appendChild(strip.cloneNode(true));
    document.body.appendChild(pin);
    return pin;
  }

  function headerBottom() {
    var header = document.querySelector('.site-header');
    if (!header || getComputedStyle(header).position !== 'fixed') return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  function updatePin() {
    if (!C.grid || !root.classList.contains('bfc-live')) return;
    var p = ensurePin();
    if (!p) return;
    var tile = document.querySelector('#searchspring-content .ss__results > .bfc-tile');
    var top = headerBottom();
    p.style.setProperty('--bfc-pin-top', top + 'px');
    p.classList.toggle('is-on', !!(mqMobile.matches && tile && tile.getBoundingClientRect().bottom <= top));
  }

  var pinQueued = false;
  function queuePin() {
    if (pinQueued) return;
    pinQueued = true;
    requestAnimationFrame(function () { pinQueued = false; updatePin(); });
  }

  function removeTiles() {
    var tiles = document.querySelectorAll('.bfc-tile');
    for (var i = 0; i < tiles.length; i++) tiles[i].remove();
    var style = document.getElementById('bfc-order');
    if (style) style.remove();
    if (pin) { pin.remove(); pin = null; }
  }

  function stop() {
    if (timer) clearInterval(timer);
    if (observer) observer.disconnect();
    timer = observer = null;
  }

  function tick() {
    var now = Date.now();
    var s = state(now);
    var wasLive = root.classList.contains('bfc-live');

    root.classList.toggle('bfc-live', s === 'live');
    root.classList.toggle('bfc-ended', s === 'post' && !!C.endedText);
    if (s !== 'live') {
      root.classList.remove('bfc-final');
      if (s === 'post' || s === 'invalid') {
        removeTiles();
        stop();
        // Announcement bar was hidden behind the countdown; let Swiper re-measure.
        if (wasLive) {
          try { swiperannou.update(); } catch (e) {}
        }
      }
      return;
    }

    root.classList.toggle('bfc-final', end - now <= C.finalMs);
    // Hourly loop: after the end, count down to the top of each hour on the real clock.
    var rem = now >= end ? 3600000 - now % 3600000 : end - now;

    var t = Math.floor(rem / 1000);
    var d = Math.floor(t / 86400);
    var h = Math.floor((t % 86400) / 3600);
    var m = Math.floor((t % 3600) / 60);
    var sec = t % 60;

    setAll('[data-bfc-d]', pad(d));
    setAll('[data-bfc-h]', pad(h));
    setAll('[data-bfc-m]', pad(m));
    setAll('[data-bfc-s]', pad(sec));

    if (C.grid) {
      ensureTile();
      updatePin();
    }
  }

  function init() {
    tick();
    var initial = state(Date.now());
    if (initial === 'post' || initial === 'invalid') return;
    timer = setInterval(tick, 1000);

    if (C.grid) {
      var host = document.getElementById('searchspring-content');
      if (host && window.MutationObserver) {
        observer = new MutationObserver(function () {
          if (root.classList.contains('bfc-live')) ensureTile();
        });
        observer.observe(host, { childList: true, subtree: true });
      }
      window.addEventListener('resize', function () {
        var list = gridList();
        if (list && root.classList.contains('bfc-live')) updateOrder(list);
        queuePin();
      });
      // The sticky header slides in/out on scroll; re-measure during and just after.
      window.addEventListener('scroll', function () {
        queuePin();
        clearTimeout(window.__bfcPinT);
        window.__bfcPinT = setTimeout(updatePin, 320);
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
